
import { useEffect, useRef, useState } from 'react';

export default function Languages() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const languages = [
    { name: 'Anglais', percentage: 75, color: 'bg-blue-500' },
    { name: 'Français', percentage: 55, color: 'bg-red-500' },
    { name: 'Arabe', percentage: 80, color: 'bg-green-500' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="lang" className="py-20 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">
          Langues
        </h2>

        <div className="max-w-3xl mx-auto space-y-8">
          {languages.map((language, index) => (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 flex items-center justify-center ${language.color} text-white rounded-lg`}>
                    <i className="ri-global-line text-xl"></i>
                  </div>
                  <span className="font-semibold text-gray-900 text-lg">{language.name}</span>
                </div>
                <span className="font-bold text-gray-900">{language.percentage}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                <div
                  className={`h-full ${language.color} rounded-full transition-all duration-1000 ease-out relative overflow-hidden`}
                  style={{ width: isVisible ? `${language.percentage}%` : '0%' }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
